// REACT
import React, { Component } from "react";

// GRID
import { Container } from "react-grid-system";

// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors";
import "./about.css";

// CONTAINERS
import Gallery from "../Gallery/gallery.container";
import Map from "../Map/map.container";

// COMPONENTS
import Checkbox from "../../components/checkboxDump/checkbox";
import ReceiptVideo from "../../components/receiptVideo/receiptvideo.component";

// ICONS
import FaClockO from "react-icons/lib/fa/clock-o";
import FaUser from "react-icons/lib/fa/user";
import Confection from "../../assets/images/Icons/ic-dificuldade.svg";

// QRCODE
import QRCode from "qrcode-react";

//HTML PARSER
import ReactHtmlParser from "react-html-parser";

class About extends Component {
  state = {
    seletedTab: 0,
  };

  changeTab = (seletedTab) => {
    this.setState({
      seletedTab: seletedTab,
    });
  };

  decodeRegion(r) {
    if (r === 1) {
      return "Norte";
    } else if (r === 2) {
      return "Centro";
    } else {
      return "Sul";
    }
  }

  render() {
    const { type, t, data, qr, url, img } = this.props;

    let seletedTab = this.state.seletedTab;

    return (
      <Container>
        <AboutContent>
          {/***************** LEFT *****************/}
          <AboutLeft>
            {/* RESTAURANTES */}
            {type === "0" && (
              <span>
                <Title>{t("Sobre o Restaurante")}</Title>
                <AboutText>
                  {data.about === null
                    ? t("Sem informação disponível")
                    : data.about}
                </AboutText>
                <RestaurantesInfo>
                  {/* PREÇO */}
                  {data.price === null ? (
                    ""
                  ) : (
                    <RestaurantesInfoCol>
                      <RestaurantesInfoColTitle>
                        {t("Preço médio")} <span>({t("por pessoa")})</span>
                      </RestaurantesInfoColTitle>
                      <RestaurantesInfoColText>
                        {data.price === "1" && <span>€</span>}
                        {data.price === "2" && <span>€€</span>}
                        {data.price === "3" && <span>€€€</span>}
                        {data.price === "4" && <span>€€€€</span>}
                      </RestaurantesInfoColText>
                    </RestaurantesInfoCol>
                  )}
                  {/* CAPACIDADE TOTAL */}
                  {data.capacity.total !== 0 && (
                    <RestaurantesInfoCol>
                      <RestaurantesInfoColTitle>
                        {t("Capacidade Total")}
                      </RestaurantesInfoColTitle>
                      <RestaurantesInfoColText>
                        {data.capacity.total} {t("pessoas")}
                      </RestaurantesInfoColText>
                    </RestaurantesInfoCol>
                  )}
                  {/* CAPACIDADE EXTERIOR */}
                  {data.capacity.exterior !== null && (
                    <RestaurantesInfoCol>
                      <RestaurantesInfoColTitle>
                        {t("Capacidade Exterior")}
                      </RestaurantesInfoColTitle>
                      <RestaurantesInfoColText>
                        {data.capacity.exterior} {t("pessoas")}
                      </RestaurantesInfoColText>
                    </RestaurantesInfoCol>
                  )}
                  {/* CAPACIDADE INTERIOR */}
                  {data.capacity.interior !== null && (
                    <RestaurantesInfoCol>
                      <RestaurantesInfoColTitle>
                        {t("Capacidade Interior")}
                      </RestaurantesInfoColTitle>
                      <RestaurantesInfoColText>
                        {data.capacity.interior} {t("pessoas")}
                      </RestaurantesInfoColText>
                    </RestaurantesInfoCol>
                  )}
                  {/* OUTRAS INFORMAÇÕES */}
                  {data.notes !== null && (
                    <RestaurantesInfoCol>
                      <RestaurantesInfoColTitle>
                        {t("Outras informações")}
                      </RestaurantesInfoColTitle>
                      <RestaurantesInfoColText>
                        {data.notes}
                      </RestaurantesInfoColText>
                    </RestaurantesInfoCol>
                  )}
                </RestaurantesInfo>
                {data.coordinates.lng !== null &&
                  data.coordinates.lat !== null && (
                    <Map
                      lng={data.coordinates.lng}
                      lat={data.coordinates.lat}
                      address={data.address}
                      t={t}
                    />
                  )}
              </span>
            )}
            {/* RESTAURANTES */}

            {/* PRODUTO */}
            {type === "1" && (
              <span>
                {data.producers.length > 0 && (
                  <ProductTab>
                    <Tabs>
                      <Tab
                        onClick={(seletedTab) => this.changeTab(0)}
                        className={seletedTab === 0 ? "activeTab" : ""}
                      >
                        <div>{t("AGRUPAMENTO DE PRODUTORES")}</div>
                      </Tab>
                      <Tab
                        onClick={(seletedTab) => this.changeTab(1)}
                        className={seletedTab === 1 ? "activeTab" : ""}
                      >
                        <div>{t("CONTROLO E CERTIFICAÇÃO")}</div>
                      </Tab>
                    </Tabs>
                    {seletedTab === 0 && (
                      <ProductTabContent>
                        <Top>
                          <ProviderLogo>
                            <img
                              src={data.producers[0].media[5].path}
                              alt={data.producers[0].name}
                            />
                          </ProviderLogo>
                          <ProviderName>
                            <ProviderBold>
                              {data.producers[0].name}
                            </ProviderBold>
                            <ProviderText>
                              {data.producers[0].description}
                            </ProviderText>
                          </ProviderName>
                        </Top>
                        {data.producers[0].address !== "" && (
                          <Middle>
                            <ProviderBold>{t("Morada")}</ProviderBold>
                            <ProviderText>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: data.producers[0].address,
                                }}
                              />
                            </ProviderText>
                          </Middle>
                        )}
                        <Bottom>
                          {data.producers[0].contact !== "" && (
                            <Block>
                              <ProviderBold>{t("Telefone")}</ProviderBold>
                              <ProviderText>
                                {data.producers[0].contact}
                              </ProviderText>
                            </Block>
                          )}
                          {data.producers[0].email !== "" && (
                            <Block>
                              <ProviderBold>Email</ProviderBold>
                              <ProviderText>
                                <a href={"mailto:" + data.producers[0].email}>
                                  {data.producers[0].email}
                                </a>
                              </ProviderText>
                            </Block>
                          )}
                          {data.producers[0].website !== null && (
                            <Block>
                              <ProviderBold>Website</ProviderBold>
                              <ProviderText className="websiteLink">
                                <a
                                  href={data.producers[0].website}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {t("Visite")}
                                </a>
                              </ProviderText>
                            </Block>
                          )}
                        </Bottom>
                      </ProductTabContent>
                    )}
                    {seletedTab === 1 && (
                      <ProductTabContent>
                        {data.certifiers[0].name !== "" && (
                          <span>
                            <Top>
                              <ProviderLogo>
                                <img
                                  src={data.certifiers[0].media[11].path}
                                  alt={data.certifiers[0].name}
                                />
                              </ProviderLogo>
                              <ProviderName>
                                <ProviderBold>
                                  {data.certifiers[0].name}
                                </ProviderBold>
                                <ProviderText>
                                  {data.certifiers[0].description}
                                </ProviderText>
                              </ProviderName>
                            </Top>
                            {data.certifiers[0].address !== "" && (
                              <Middle>
                                <ProviderBold>{t("Morada")}</ProviderBold>
                                <ProviderText>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: data.certifiers[0].address,
                                    }}
                                  />
                                </ProviderText>
                              </Middle>
                            )}
                            <Bottom>
                              {data.certifiers[0].contact !== "" && (
                                <Block>
                                  <ProviderBold>{t("Telefone")}</ProviderBold>
                                  <ProviderText>
                                    {data.certifiers[0].contact}
                                  </ProviderText>
                                </Block>
                              )}
                              {data.certifiers[0].email !== "" && (
                                <Block>
                                  <ProviderBold>Email</ProviderBold>
                                  <ProviderText>
                                    {data.certifiers[0].email}
                                  </ProviderText>
                                </Block>
                              )}
                              {data.certifiers[0].website !== null && (
                                <Block>
                                  <ProviderBold>Website</ProviderBold>
                                  <ProviderText className="websiteLink">
                                    <a
                                      href={data.certifiers[0].website}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {t("Visite")}
                                    </a>
                                  </ProviderText>
                                </Block>
                              )}
                            </Bottom>
                          </span>
                        )}
                        {data.certifiers[0].name === "" && (
                          <NoData>{t("Sem dados disponíveis")}</NoData>
                        )}
                      </ProductTabContent>
                    )}
                  </ProductTab>
                )}
              </span>
            )}
            {/* PRODUTO */}

            {/* RECEITAS */}
            {type === "2" && (
              <span>
                {/* <RegionInfo>
                                   <RegionTitle>{t('Região')}:</RegionTitle>
                                   <RegionText>{
                                        data.region === null ?
                                            t('Sem informação disponível')  
                                            :
                                            this.decodeRegion(data.region)

                                    }
                                    </RegionText>
                                </RegionInfo> */}
                <DishInfo>
                  <DishItem>
                    <DishIcon>
                      <FaClockO />
                    </DishIcon>
                    <DishTitle>{t("Preparação")}</DishTitle>
                    <DishText>
                      {data.cooking_time !== null ? data.cooking_time : "N.D."}
                    </DishText>
                  </DishItem>
                  <DishItem>
                    <DishIcon>
                      <FaClockO />
                    </DishIcon>

                    <DishTitle>{t("Cozinhar")}</DishTitle>
                    <DishText>
                      {data.cooking_time !== null ? data.cooking_time : "N.D."}
                    </DishText>
                  </DishItem>
                  <DishItem>
                    <DishIcon>
                      <img src={Confection} alt="" />
                    </DishIcon>
                    <DishTitle>{t("Dificuldade")}</DishTitle>
                    <DishText>
                      {data.dificulty !== null ? data.dificulty : "N.D."}
                    </DishText>
                  </DishItem>
                  <DishItem>
                    <DishIcon>
                      <FaUser />
                    </DishIcon>
                    <DishTitle>{t("Número de Pessoas")}</DishTitle>
                    <DishText>
                      {data.number_people !== null
                        ? data.number_people
                        : "N.D."}
                    </DishText>
                  </DishItem>
                </DishInfo>
                <Title>{t("História do Prato")}</Title>
                <AboutText>
                  {data.history === null
                    ? t("Sem informação disponível")
                    : data.history}
                </AboutText>
                {data.observations && (
                  <Observations>
                    <ObsTitle>{t("Observações")}</ObsTitle>
                    <ObsText>{data.observations}</ObsText>
                  </Observations>
                )}

                {data.ingredients.length > 1 && (
                  <Ingredients>
                    <IngredientsTitle>{t("INGREDIENTES")}</IngredientsTitle>
                    {data.ingredients.map((ingredient, index) => {
                      const description = ingredient.product_id ? (
                        <IngredientsTextLink
                          href={`../${this.props.t("produtos")}/${
                            ingredient.product_id
                          }`}
                        >
                          {ingredient.description}
                        </IngredientsTextLink>
                      ) : (
                        ingredient.description
                      );
                      return (
                        <IngredientsRow key={index}>
                          <Checkbox />
                          <IngredientsText>
                            <span>{ingredient.quantity}</span> {description}
                          </IngredientsText>
                        </IngredientsRow>
                      );
                    })}
                  </Ingredients>
                )}
              </span>
            )}
            {/* RECEITAS */}

            {/* EVENTOS */}
            {type === "3" && <Title>Sobre o Evento</Title>}
            {/* EVENTOS */}
          </AboutLeft>
          {/***************** LEFT *****************/}

          {/***************** RIGHT *****************/}
          <AboutRight>
            {/* RESTAURANTS */}
            {type === "0" && <Gallery media={data.media} t={t} />}
            {/***** RESTAURANTS *****/}

            {/***** PRODUTO *****/}
            {type === "1" && (
              <span>
                <Gallery media={data.media[2]} t={t} />
              </span>
            )}
            {/***** PRODUTO *****/}

            {/***** RECEIPS *****/}
            {type === "2" && (
              <React.Fragment>
                {data.video_url !== null && (
                  <ReceiptVideo videoUrl={data.video_url} />
                )}
                <Gallery t={t} media={data.media} />
                {data.source !== null && (
                  <RecipeSource>
                    <SourceTitle>{t("Fonte")}</SourceTitle>
                    <SourceText>{ReactHtmlParser(data.source)}</SourceText>
                  </RecipeSource>
                )}

                <ContentQrCode>
                  <QRCode value={url} />
                </ContentQrCode>
                <CodeText>{t("codeRecipe")}</CodeText>
              </React.Fragment>
            )}

            {/***** RECEIPS *****/}

            {/***** EVENTS *****/}
            {type === "3" && <Gallery />}
            {/***** EVENTS *****/}
          </AboutRight>
          {/***************** RIGHT *****************/}
        </AboutContent>

        {/* PRODUCTS */}
        {type === "1" && (
          <Product>
            {data.description_historic !== null && (
              <ProductMargin>
                <Title>{t("História do Produto")}</Title>
                <AboutText>{data.description_historic}</AboutText>
              </ProductMargin>
            )}
            {data.description_technic !== null && (
              <ProductMargin>
                <Title>{t("Descrição Técnica")}</Title>
                <AboutText>{data.description_technic}</AboutText>
              </ProductMargin>
            )}
            {data.production_method !== null && (
              <span>
                <CollapseTitle>{t("MÉTODO DE PRODUÇÃO")}</CollapseTitle>
                <CollapseText>{data.production_method}</CollapseText>
              </span>
            )}
            {data.production_season !== null && (
              <span>
                <CollapseTitle>{t("ÉPOCA DE PRODUÇÃO")}</CollapseTitle>
                <CollapseText>{data.production_season}</CollapseText>
              </span>
            )}
            {data.annual_production !== null && (
              <span>
                <CollapseTitle>{t("PRODUÇÃO ANUAL")}</CollapseTitle>
                <CollapseText>{data.annual_production}</CollapseText>
              </span>
            )}
            {data.geo_area !== null && (
              <span>
                <CollapseTitle>{t("ÁREA GEOGRÁFICA")}</CollapseTitle>
                <CollapseText>{data.geo_area}</CollapseText>
              </span>
            )}
            {data.details_specific !== null && (
              <span>
                <CollapseTitle>
                  {t("CARACTERÍSTICAS PARTICULARES")}
                </CollapseTitle>
                <CollapseText>{data.details_specific}</CollapseText>
              </span>
            )}
            {data.details_organoleptic !== null && (
              <span>
                <CollapseTitle>
                  {t("CARACTERÍSTICAS ORGANOLÉTICAS")}
                </CollapseTitle>
                <CollapseText>{data.details_organoleptic}</CollapseText>
              </span>
            )}
            {data.allergenics !== null && (
              <span>
                <CollapseTitle>{t("ALERGÉNIOS")}</CollapseTitle>
                <CollapseText>{data.allergenics}</CollapseText>
              </span>
            )}
            {data.conservation !== null && (
              <span>
                <CollapseTitle>{t("CONDIÇÕES DE CONSERVAÇÃO")}</CollapseTitle>
                <CollapseText>{data.conservation}</CollapseText>
              </span>
            )}
            {data.notebook_specs !== null && (
              <span>
                <CollapseTitle>{t("CADERNOS DE ESPECIFICAÇÕES")}</CollapseTitle>
                <CollapseText>
                  <Download>
                    <a href={data.notebook_specs} target="blanck">
                      Download PDF
                    </a>
                  </Download>
                </CollapseText>
              </span>
            )}
            {(data.legislation_dr !== null ||
              data.legislation_newspaper !== null) && (
              <span>
                <CollapseTitle>{t("LEGISLAÇÃO")}</CollapseTitle>
                <CollapseText>
                  <p>{data.legislation_dr}</p>
                  <p>{data.legislation_newspaper}</p>
                </CollapseText>
              </span>
            )}
            {/* QR CODE*/}
            {qr && (
              <React.Fragment>
                <CollapseTitle>QR CODE</CollapseTitle>
                <ContentQrCode>
                  <QRCode value={url} />
                </ContentQrCode>
                <CodeText>{t("codeProduct")}</CodeText>
              </React.Fragment>
            )}
          </Product>
        )}
      </Container>
    );
  }
}

export default About;

// PAGE
const AboutContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 80px;

  @media screen and (max-width: 992px) {
    display: block;
    padding-bottom: 40px;
  }
`;
const AboutLeft = styled.div`
  width: 55%;

  @media screen and (max-width: 1200px) {
    width: 55%;
  }

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`;
const AboutRight = styled.div`
  width: 35%;

  @media screen and (max-width: 1200px) {
    width: 40%;
  }

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`;
const Title = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 22px;
  font-weight: bold;
  line-height: 48px;
  margin-bottom: 20px;
  position: relative;
  text-transform: uppercase;

  &:after {
    content: "";
    width: 32px;
    height: 3px;
    background-color: #11837b;
    position: absolute;
    bottom: -2px;
    left: 0;
  }
`;
const AboutText = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 16px;
  line-height: 26px;
`;

// RESTAURANTS
const RestaurantesInfo = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 50px;
  margin-top: 20px;
`;
const RestaurantesInfoCol = styled.div`
  padding: 15px;
  border-radius: 3px;
  margin-top: 15px;
  margin-right: 15px;
  background-color: #fff;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);
`;
const RestaurantesInfoColTitle = styled.div`
  font-family: "PT Sans";
  font-size: 16px;
  color: ${Colors.primary};
  font-weight: 600;
  margin-bottom: 5px;

  span {
    font-size: 14px;
  }
`;
const RestaurantesInfoColText = styled.div`
  font-family: "PT Sans";
  font-size: 16px;
  color: hsl(0, 0%, 17%);
`;

// PRODUCTS
const ProductMargin = styled.div`
  margin-bottom: 50px;
`;
const Top = styled.div`
  display: flex;
  align-items: center;
`;
const ProviderName = styled.div``;
const ProviderLogo = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 80px;
  margin-right: 20px;

  img {
    width: 80px;
    height: 80px;
    border-radius: 80px;
    border: 1px solid #979797;
    object-fit: cover;
  }
`;
const Middle = styled.div`
  margin-top: 30px;
`;
const ProviderText = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  color: hsl(0, 0%, 17%);
  font-size: 16px;
  font-family: "PT Sans";

  a {
    color: #535353;
    cursor: pointer;
  }
`;
const Bottom = styled.div`
  display: flex;
  flex-flow: row wrap;
`;
const Block = styled.div`
  margin-right: 20px;
  margin-top: 30px;
`;
const ProviderBold = styled.div`
  color: hsl(0, 0%, 17%);
  font-size: 16px;
  font-family: "PT Sans";
  font-weight: 600;
`;
const Product = styled.div`
  margin-right: auto;
  margin-left: auto;
`;
const Download = styled.div`
  padding: 5px 0px;
  a {
    color: #11837b;
  }
`;

// RECEIPS
const DishInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  flex-flow: row wrap;
`;
const DishItem = styled.div`
  margin-right: 25px;
  margin-top: 10px;
`;
const DishIcon = styled.div`
  font-size: 30px;
  color: hsl(0, 0%, 17%);

  img {
    width: 25px;
    height: 25px;
  }
`;
const DishTitle = styled.div`
  color: hsl(0, 0%, 17%);
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  margin-top: 10px;
  margin-bottom: 5px;
`;
const DishText = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 16px;
  line-height: 22px;
  text-transform: uppercase;
`;
const Ingredients = styled.div`
  margin-top: 30px;

  @media screen and (max-width: 992px) {
    margin-bottom: 50px;
  }
`;
const IngredientsTitle = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 22px;
  font-weight: bold;
  line-height: 48px;
  margin-bottom: 20px;
  position: relative;
  text-transform: uppercase;

  &:after {
    content: "";
    width: 32px;
    height: 3px;
    background-color: #11837b;
    position: absolute;
    bottom: -2px;
    left: 0;
  }
`;
const IngredientsRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6ebec;
  height: 64px;
  padding: 0 30px;
`;
const IngredientsText = styled.div`
  margin-left: 10px;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 16px;
  line-height: 16px;
  margin-top: 2px;

  span {
    font-weight: 600;
  }
`;
const IngredientsTextLink = styled.a`
  margin-left: 10px;
  color: #11837b;
  font-family: "PT Sans";
  font-size: 16px;
  line-height: 16px;
  margin-top: 2px;

  span {
    font-weight: 600;
  }
`;
const Observations = styled.div`
  margin-top: 30px;
`;

const ObsTitle = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 22px;
  font-weight: bold;
  line-height: 48px;
  margin-bottom: 20px;
  position: relative;
  text-transform: uppercase;

  &:after {
    content: "";
    width: 32px;
    height: 3px;
    background-color: #11837b;
    position: absolute;
    bottom: -2px;
    left: 0;
  }
`;

const ObsText = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 16px;
  line-height: 26px;
`;
// COLLAPSE TITLE
const CollapseTitle = styled.div`
  height: 30px;
  line-height: 30px;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 18px;
  font-weight: 600;
  position: relative;

  &:after {
    content: "";
    width: 40px;
    height: 3px;
    background-color: #11837b;
    position: absolute;
    bottom: -10px;
    left: 0;
  }
`;
const CollapseText = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 35px;
  margin-top: 25px;

  p {
    margin: 0;
  }
`;

// TABS
const ProductTab = styled.div`
  background-color: #fff;
  border-radius: 3px;

  @media screen and (max-width: 991px) {
    margin-bottom: 25px;
    margin-top: -50px;
  }
`;
const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e6ebec;
  height: 65px;
`;
const Tab = styled.div`
  width: 50%;
  text-align: center;
  cursor: pointer;
  color: hsl(0, 0%, 17%);
  opacity: 0.5;
  font-size: 15px;
  font-family: "PT Sans";
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    margin-left: 10px;
    margin-right: 10px;
  }
`;

const ProductTabContent = styled.div`
  padding: 30px 0px;
`;
const NoData = styled.div`
  width: 100%;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 15px;
  text-align: center;
`;
const ContentQrCode = styled.div`
  width: 128px;
  height: 128px;
  padding: 10px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);
  margin-top: 35px;
  cursor: pointer;
`;

const CodeText = styled.div`
  color: hsl(0, 0%, 17%);
  font-size: 15px;
  font-family: "PT Sans";
  margin-top: 15px;
`;

const RecipeSource = styled.div``;
const SourceTitle = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 22px;
  font-weight: bold;
  line-height: 48px;
  margin-bottom: 30px;
  position: relative;
  text-transform: uppercase;

  &:after {
    content: "";
    width: 32px;
    height: 3px;
    background-color: #11837b;
    position: absolute;
    bottom: -2px;
    left: 0;
  }
`;
const SourceText = styled.div`
  color: hsl(0, 0%, 17%);
  font-size: 15px;
  font-family: "PT Sans";
  margin-top: 15px;
`;



// WEBPACK FOOTER //
// ./src/containers/About/about.container.js